const postLiveAccountAvailabilityPayload = (formField) => {
  const payload = { name: formField?.accountId };

  if (formField?.platform) payload.ecommerceId = `${formField?.platform?.id}`;

  return payload;
};

export default postLiveAccountAvailabilityPayload;
